import { Locale } from "types/provider/I18n";

export const LOCALES: Locale[] = ["vi", "en"];
export const DEFAULT_LOCALE: Locale = "vi";

/** Chuỗi bất kỳ từ URL → locale hợp lệ (mặc định tiếng Việt). */
export const normalizeLocale = (value?: string): Locale =>
  LOCALES.includes(value as Locale) ? (value as Locale) : DEFAULT_LOCALE;

/**
 * Gắn tiền tố ngôn ngữ vào đường dẫn nội bộ.
 * Tiếng Việt là mặc định nên KHÔNG có tiền tố: "/uu-dai" giữ nguyên,
 * còn tiếng Anh thành "/en/uu-dai".
 */
export const localizePath = (path: string, locale: Locale): string => {
  if (!path || !path.startsWith("/")) return path; // link ngoài (http…) để nguyên
  if (locale === DEFAULT_LOCALE) return path;
  if (stripLocale(path) !== path) return path; // đã có tiền tố → không gắn lần 2 (/en/en/…)
  if (path === "/") return `/${locale}`;
  return `/${locale}${path}`;
};

/** Bỏ tiền tố ngôn ngữ khỏi đường dẫn — dùng khi đổi ngôn ngữ tại chỗ. */
export const stripLocale = (path: string): string => {
  for (const l of LOCALES) {
    if (path === `/${l}`) return "/";
    if (path.startsWith(`/${l}/`)) return path.slice(l.length + 1);
  }
  return path;
};
